import {FormBuilder, FormControl, ReactiveFormsModule, UntypedFormGroup, Validators} from '@angular/forms';
import {Component, OnInit, ViewChild} from '@angular/core';
import {ProgressComponent} from '../progress/progress.component';
import {Auth, sendPasswordResetEmail} from '@angular/fire/auth';
import {MatCard, MatCardContent, MatCardHeader, MatCardImage, MatCardSubtitle, MatCardTitle} from '@angular/material/card';
import {MatError, MatInput} from '@angular/material/input';
import {RouterLink} from '@angular/router';
import {MatButton} from '@angular/material/button';
import {NgOptimizedImage} from '@angular/common';
import {MatFormField} from '@angular/material/form-field';

@Component({
    selector: 'app-login',
    templateUrl: './forgot-password-form.component.html',
    styleUrls: ['./forgot-password-form.component.scss'],
    imports: [
        ProgressComponent,
        MatCard,
        MatCardHeader,
        MatCardTitle,
        MatCardSubtitle,
        MatCardContent,
        MatFormField,
        ReactiveFormsModule,
        MatInput,
        MatError,
        RouterLink,
        MatButton,
        MatCardImage,
        NgOptimizedImage
    ],
    standalone: true
})
export class ForgotPasswordFormComponent implements OnInit {
    form: UntypedFormGroup;
    @ViewChild(ProgressComponent, {static: true}) progress: ProgressComponent;
    public globalErrorMessage = '';
    public displayLoginButton = false;

    constructor(
        private formBuilder: FormBuilder,
        private fireAuth: Auth) {
    }

    ngOnInit() {
        this.form = this.formBuilder.group({
            email: new FormControl('', [Validators.required, Validators.email]),
        });
    }

    requestNewPassword() {
        if (this.form.valid) {
            this.progress.setVisible(true);
            this.globalErrorMessage = '';
            const self = this;
            sendPasswordResetEmail(this.fireAuth, this.form.get('email').value).then(function() {
                self.progress.setVisible(false);
                self.globalErrorMessage = 'Password reset email sent. Please check your inbox.';
                self.displayLoginButton = true;
            }).catch(function(error) {
                self.progress.setVisible(false);
                if (error.error && error.error.message) {
                    self.globalErrorMessage = error.error.message;
                } else {
                    self.globalErrorMessage = 'Unknown Error, Please try again.';
                }
            });
        }
    }
}
